/* eslint-disable no-undef */
import { SERVER_URL } from './config';

const authProvider = {
  login: ({ username, password }) => {
    const request = new Request(`${SERVER_URL}/login`, {
      method: "POST",
      body: JSON.stringify({ username, password }),
      headers: new Headers({ "Content-Type": "application/json" }),
    });
    
    return fetch(request)
      .then(async (response) => {
        let responseData;
        try {
          responseData = await response.json();
        } catch (e) {
          responseData = { message: response.statusText };
        }

        if (response.status < 200 || response.status >= 300) {
          throw new Error(responseData.message || response.statusText);
        }
        
        return responseData;
      })
      .then((data) => {
        if (data.token) {
          localStorage.setItem("token", data.token);
        } else {
          throw new Error("Token não encontrado na resposta");
        }
      })
      .catch((error) => {
        throw new Error(error.message || "Erro de conexão");
      });
  },
  
  logout: () => {
    localStorage.removeItem("token");
    return Promise.resolve("/login");
  },
  
  checkAuth: () =>
    localStorage.getItem("token") ? Promise.resolve() : Promise.reject(),
    
  checkError: (error) => {
    const status = error.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem("token");
      return Promise.reject();
    }
    return Promise.resolve();
  },
  
  getPermissions: () => {
    return Promise.resolve();
  },
};

export default authProvider;